/* eslint-disable camelcase */
import { type FC, useState } from "react";
import { Icon } from "@root/shared/components/Icon";
import { Colors } from "@root/shared/utils/colors";
import type { PickupButtonContentProps } from "@clientFrontend/features/scout/components/UserDetailModal/uiParts/Header";
import * as styles from "./styles.css";

type Props = {
  pickupButtonContent: PickupButtonContentProps;
  pickupGaEvents: {
    gaAction: string;
    gaLabel: string;
  };
  pickupReleaseGaEvents: {
    gaAction: string;
    gaLabel: string;
  };
};

export const PickupButton: FC<Props> = ({
  pickupButtonContent: { isPickedUp, loading, onClickPickup },
  pickupGaEvents,
  pickupReleaseGaEvents,
}) => {
  const [showPickedMessage, setShowPickedMessage] = useState(false);
  const [isShowTooltip, setIsShowTooltip] = useState(false);

  const showTooltip = () => {
    setIsShowTooltip(true);
  };

  const hideTooltip = () => {
    setIsShowTooltip(false);
    setShowPickedMessage(false);
  };

  const handleOnClick = () => {
    onClickPickup();

    if (isPickedUp) {
      setShowPickedMessage(false);
    } else {
      setShowPickedMessage(true);
    }
  };

  const gaAction = isPickedUp ? pickupReleaseGaEvents.gaAction : pickupGaEvents.gaAction;
  const gaLabel = isPickedUp ? pickupReleaseGaEvents.gaLabel : pickupGaEvents.gaLabel;

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        name="commit"
        className={`${styles.button} ${loading ? styles.loadingButton : ""}`}
        onClick={handleOnClick}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        data-ga-label={gaLabel}
        data-ga-action={gaAction}
      >
        {isPickedUp ? (
          <Icon name="mark-ticket" color={Colors.PRIMARY} />
        ) : (
          <Icon name="mark-ticket-outline" color={Colors.PRIMARY} />
        )}
      </button>
      {!loading && isShowTooltip && (
        <div className={styles.toolTip}>
          {showPickedMessage ? (
            <>
              <p className={styles.toolTipIconWrapper}>
                <Icon name="mark-ticket" color={Colors.PRIMARY} />
              </p>
              <p>ピックアップしました！</p>
            </>
          ) : (
            <>
              <p className={styles.toolTipIconWrapper}>
                <Icon name="mark-ticket-outline" color={Colors.PRIMARY} />
              </p>
              <p>
                スカウトを送る前に
                <br />
                気になる候補者をピックアップできます
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
};
